import { render, staticRenderFns } from "./IconMarkRead.vue?vue&type=template&id=5bf4470d&scoped=true"
import script from "./IconMarkRead.vue?vue&type=script&lang=js"
export * from "./IconMarkRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf4470d",
  null
  
)

export default component.exports